@if(status==6){<span class="color-green f-11">{{approverName}} (approved)<span
        class="d-block text-charcoal-black line-height-10">on {{approvalData|date:'dd-MMM-yyy'}}</span></span>}
@if(status==5){<span class="color-red f-11">{{approverName}} (rejected)<span
        class="d-block text-charcoal-black line-height-10">on {{approvalData|date:'dd-MMM-yyy'}}</span></span>}
@if(status==-1 || approvalData=='N/A'){<span>{{approvalData}}</span>}